<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    background-color: #2F4F7F;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .nav {
    margin-left: 8px;
  }

  .nav-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 8px;
    align-items: center;
    height: 60px;
  }

  .nav-item {
    position: relative;
  }

  .nav-link {
    color: white;
    padding: 0 12px;
    display: inline-block;
    text-decoration: none;
    height: 60px;
    line-height: 60px;
    cursor: pointer;
  }

  .dropdown-menu {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    background: #fff;
    color: #333;
    min-width: 200px;
    border-radius: 4px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
    z-index: 100;
    padding: 6px 0;
  }

  .dropdown-menu li a {
    display: block;
    padding: 8px 16px;
    color: #333;
    text-decoration: none;
  }

  .dropdown:hover .dropdown-menu {
    display: block;
  }

  .dropdown-menu li a:hover {
    background: #f5f5f5;
  }

  .toolbar #twitter-logo {
    height: 60px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: flex;
    margin: 82px auto 32px;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(black, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: calc(100vh - 95px);
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #eee;
    text-decoration: none;
  }

  a:hover {
    color: #000;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
    border-color: rgba(27,31,35,.35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }


  /* Responsive Styles */
  @media screen and (max-width: 767px) {

    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }

  div.logo {
    display: flex;
    align-items: center;
    padding: 0px;
  }

  div.logo img {
    margin: 0;
    height: 64px;
  }
  span.qty_cart {
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 2px 6px;
    font-size: 12px;
    position: relative;
    top: 1px;
    left: 3px;
  }
</style>

<!-- Toolbar -->
<div class="toolbar" role="banner">
  <div class="logo">
  <a routerLink="/login" title="Entrar">
    <img
      width="120"
      alt="Ferreira Auto"
      src="assets/banner/ferrieira-auto.png"
    />
  </a>
  <nav class="nav" role="navigation">
    <ul class="nav-list">
      <li class="nav-item" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <a class="nav-link" routerLink="/dashboard" title="Dashboard">Dashboard</a>
      </li>

      <li class="nav-item dropdown" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <p class="nav-link">Despesas ▾</p>
        <ul class="dropdown-menu" role="menu">
          <li role="none"><a role="menuitem" routerLink="/despesas/tipo-despesas">Tipo de despesas</a></li>
          <li role="none"><a role="menuitem" routerLink="/despesas/cadastro">Cadastro de despesas</a></li>
          <li role="none"><a role="menuitem" routerLink="/despesas/listagem">Listagem de despesas</a></li>
        </ul>
      </li>

      <li class="nav-item" *ngIf="!authService.isLoggedIn">
        <a class="nav-link" routerLink="/login" title="Logar">Logar</a>
      </li>

      <li class="nav-item" *ngIf="!authService.isLoggedIn">
        <a role="menuitem" routerLink="/clientes/cadastro">Cadastre-se</a>    
      </li>

      <li class="nav-item dropdown" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <p class="nav-link">Status de Locação ▾</p>
        <ul class="dropdown-menu" role="menu">
          <li role="none"><a role="menuitem" routerLink="/rental/rules">Regras de Locação</a></li>
          <li role="none"><a role="menuitem" routerLink="/rental/devolucao">Devolução de Locação</a></li>
        </ul>
      </li>

      <li class="nav-item" *ngIf="authService.isLoggedIn && authService.isCustomerCommon">
        <a role="menuitem" routerLink="/endereco/cadastro">Minha Conta</a>    
      </li>

      <li class="nav-item dropdown" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <p class="nav-link">Categoria ▾</p>
        <ul class="dropdown-menu" role="menu">
          <li role="none"><a role="menuitem" routerLink="/categoria/cadastro">Cadastro de Categorias</a></li>
        </ul>
      </li>

      <li class="nav-item dropdown" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <p class="nav-link">Montadora ▾</p>
        <ul class="dropdown-menu" role="menu">
          <li role="none"><a role="menuitem" routerLink="/carmaker/cadastro">Cadastro de montadoras</a></li>
        </ul>
      </li>

      <li class="nav-item dropdown" *ngIf="authService.isLoggedIn && authService.isAdmin">
        <p class="nav-link">Modelo ▾</p>
        <ul class="dropdown-menu" role="menu">
          <li role="none"><a role="menuitem" routerLink="/model/cadastro">Cadastro de modelos</a></li>
          <li role="none"><a role="menuitem" routerLink="/model/listagem">Listagem de modelos</a></li>
        </ul>
      </li>

      <li class="nav-item" *ngIf="authService.isLoggedIn && authService.isCustomerCommon">
        <a role="menuitem" routerLink="/buy/alugar-carros">Alugar carros</a>    
      </li>

      <li class="nav-item" *ngIf="authService.isLoggedIn && authService.isCustomerCommon">
        <a role="menuitem" routerLink="/buy/car-buy">Carrinho 
          <span class="qty_cart" *ngIf="authService.isLoggedIn && authService.cartItemsCount > 0">{{ authService.cartItemsCount }}</span></a>    
      </li>

       <li class="nav-item" *ngIf="authService.isLoggedIn">
        <a class="nav-link" routerLink="/" (click)="logout()" title="Logar">Sair</a>
      </li>
    </ul>
  </nav>  </div>
    <div class="spacer"></div>
    <a aria-label="Angular on twitter" target="_blank" rel="noopener" href="https://twitter.com/angular" title="Twitter">
      <svg id="twitter-logo" height="24" data-name="Logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
        <rect width="400" height="400" fill="none"/>
        <path d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23" fill="#fff"/>
      </svg>
    </a>
</div>

<div class="content" role="main">
</div>



<router-outlet></router-outlet>

<app-customer-chat *ngIf="canShowCustomerChat"></app-customer-chat>